import React from 'react'
import { Row, Col } from 'reactstrap'

import Sidebar from '../Sidebar'

export class CommunityContainer extends React.Component {
  constructor (props) {
    super(props)
    this.state = {}
  }

  render () {
    return (
      <Row>
        <Col xs='12' lg='3'>
          <Sidebar
            hide={this.props.hide}
            location={this.props.location}
            match={this.props.match}
          />
        </Col>
        <Col>
          <Row>
            <Col lg='1' className={`d-none d-lg-block`} />
            <Col>{this.props.children}</Col>
          </Row>
        </Col>
      </Row>
    )
  }
}

export default CommunityContainer



// WEBPACK FOOTER //
// ./src/components/User/partials/Container/index.js